<template>
  <v-app >
    <LoadingScreen :show="is_loading" />

    <CheckInactivity v-if="!is_loading && isUser" :timeout="inactivity_timeout"/> 
    
    <AlertNotification/>

    <HeaderMenu v-if="!is_loading"/>

    <v-main class="content" v-if="!is_loading">
      <router-view />
    </v-main>

    <div class="footer" v-if="show_footer">
      <Footer />
    </div>

    <SupportChat />
  </v-app>
</template>

<script>
 import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
 import { get_settings, install_settings } from '@/settings.js';
 import customThemes from '@/plugins/themes.js'
 import HeaderMenu from '@/components/header/HeaderMenu'
 import Footer from '@/components/Footer'
 import SupportChat from '@/components/SupportChat'
 import LoadingScreen from '@/components/LoadingScreen'
 import CheckInactivity from '@/components/CheckInactivity'

 import AlertNotification from '@/components/AlertNotification'

 export default {
   name: 'App',

   components: {
     Footer,
     HeaderMenu,
     SupportChat,
     LoadingScreen,
     CheckInactivity,
       AlertNotification,
},

   data: () => ({
     loading: true,
   }),

   computed: {
     ...mapGetters(['isUser','user']),
     ...mapState({
       currentTheme: 'currentTheme',
       loading_lock_count: 'loading_lock_count',
     }),

     settings() {
       return get_settings() || {};
     },

     is_loading() {
       return this.loading || (this.loading_lock_count > 0);
     },

     show_footer() {
       return !!this.settings.footer;
     },

     inactivity_timeout() {
       return this.settings.inactivity_timeout;
     },
   },

   beforeMount() {
     this.usersession_install();

     // Load custom settings
     install_settings();
   },

   mounted() {
     // Dear programmer, this next line is not the correct way of doing things.
     // But its been here since at least 2021-11-11 and I'm too busy to reimplement it :v
     this.$root.$loader = this.$refs.loader;

     // Check if we need to redirect to login page
     if (this.should_redirect()) {
       if (this.$route.params.pathMatch) {
         this.$router.push({
           path: this.$route.params.pathMatch,
           query: { redirect: this.$route.fullPath }
         });
       } else {
         this.$router.push({
           name: 'login',
           query: { redirect: this.$route.fullPath }
         });
       }
       setTimeout(() => { this.loading = false }, 100); // Await router action
     } else {
       this.loading = false;
     }

     this.REFRESH_STATE(this);
     
     if (this.user) {
      // User MUST have lang, as a fallback it will use spanish language
      this.$vuetify.lang.current = this.user.lang ? this.user.lang  : 'es';
     }
     
     // Check it is mobile view
     window.addEventListener('resize', this.on_resize, true);
     this.on_resize();
   },

   beforeUnmount() {
     window.removeEventListener('resize', this.on_resize);
   },

   methods: {
     ...mapActions({
       usersession_install: 'UserSession/install',
       REFRESH_STATE: 'REFRESH_STATE',
     }),
     ...mapMutations(['SET_IS_MOBILE',]),

     // Vuetify theme changer, on the fly
     changeTheme: function(theme_name) {
       // theme_name must be a valid entry key in customThemes
       // example: changeTheme("qmkey")

       const theme = customThemes[theme_name];
       if (!theme)
         throw "Error, theme \""+theme_name+"\" not found";

       // Copy theme information to vuetify theme
       Object.keys(theme.light || {}).forEach(i => {
         this.$vuetify.theme.themes.light[i] = theme.light[i];
       });
       Object.keys(theme.dark || {}).forEach(i => {
         this.$vuetify.theme.themes.dark[i] = theme.dark[i];
       });
     },

     should_redirect() {
       return (this.$route.matched.some(record => record.meta.requiresAuth)
            && !this.isUser);
     },
     on_resize() {
       this.SET_IS_MOBILE(window.innerWidth < window.innerHeight || window.innerWidth <= 960);
     },
   },

   watch: {
     currentTheme(now) {
       this.changeTheme(now);
     },
   },
 }
</script>
